
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import TahsilatTuruPicker from "@/components/pickers/TahsilatTuruPicker.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import Kur from "@/components/inputs/Kur.vue";
import {TahsilatTuru, TahsilatTuruLabel} from "@/enum/TahsilatTuru";
import TakipBorcluPicker from "@/components/pickers/TakipBorcluPicker.vue";
import TahsilHarciPicker from "@/components/pickers/TahsilHarciPicker.vue";
import AltTahsilatTuruPicker from "@/components/pickers/AltTahsilatTuruPicker.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {TakipDurumu} from "@/enum/TakipDurumu";
import {TakipEntity} from "@/entity/TakipEntity";
import {HarcDonemiEntity} from "@/entity/HarcDonemiEntity";
import {AltTahsilatTuru} from "@/enum/AltTahsilatTuru";

@Component({
  components: {
    Kur,
    FormWrapper,
    AltTahsilatTuruPicker,
    TahsilHarciPicker,
    TakipBorcluPicker,
    Tutar,
    TahsilatTuruPicker,
    Dates,
    ParaBirimiPicker
  }
})
export default class TahsilatForm extends Mixins(ObjectInputMixin) {
  @Prop({required: true}) takip!: TakipEntity;
  @Ref('takipBorcluPicker') readonly takipBorcluPicker!: TakipBorcluPicker;
  @Prop() hideButtons!: boolean | string;

  TahsilatTuru = TahsilatTuru;
  ParaBirimi = ParaBirimi;
  TakipDurumu = TakipDurumu;
  items: Array<HarcDonemiEntity> = [];
  selectedItem: HarcDonemiEntity = new HarcDonemiEntity();
  altTahsilatTuru = AltTahsilatTuru;
  takipSonrasi: boolean = false;
  tarihKontrol: boolean = false;
  isHesaplaniyor: boolean = false;
  harctanMuafMiOranAlert:boolean = false;
  debounceTimer: number | null = null; // <-- YENİ EKLENDİ (Debounce için)

  @Watch("localValue.tahsil_harci_orani")
  changeLocalValue(){
    if (!this.localValue.id){
      this.borcluHandle(this.takip.borclular[0])
    }
  }

  borcluHandle(data:any){
    this.localValue.borclu_id = data.id
  }

  get takipSonrasiMi(){
    if (new Date(this.localValue.tarih).getTime() >= new Date(this.takip.takip_tarihi).getTime()){
      this.takipSonrasi = true
    }
    return this.takipSonrasi;
  }

  get disabledSave(){
    let disableSave = false
    if (this.takip.takip_durumu==TakipDurumu.acilmamis){
      if (this.tarihKontrol){
        disableSave = true
      }else{
        disableSave = false
      }
    }

    if (this.localValue.tahsil_harci_orani != "0.00" &&
        this.takip.alacaklilar.some(item =>
            item?.muvekkil?.kurum?.harc_muaf_mi === true
        )){
      disableSave = true;
    } else if(this.localValue.tahsil_harci_orani == "0.00" ||
        this.takip.alacaklilar.some(item =>
            item?.muvekkil?.kurum?.harc_muaf_mi === false
        )){
      disableSave = false;
    }

    return disableSave
  }

  get isHideButtons() {
    return this.hideButtons || this.hideButtons === "";
  }

  @Watch("localValue.id")
  onItemChange() {
    if (!!this.localValue.id) {
      this.localValue.net_tutar = Number(this.value.net_tutar);
    }
  }

  @Watch('localValue.tahsilat_turu')
  changeTahsilatTuru(){
    if (this.localValue.tahsilat_turu!==this.TahsilatTuru.icra){
      this.localValue.cezaevi_harci=0
    }
    this.netTutarHesapla()
  }

  load() {
    this.$emit('load');
  }

  birGunCikar() {
    let gun = new Date(this.takip.takip_tarihi).setDate(new Date(this.takip.takip_tarihi).getDate() - 1)
    let myDate = new Date(gun).toISOString().substr(0, 10);
    return myDate
  }

  get filterTurler(){
    if (new Date(this.localValue.tarih).getTime() < new Date(this.takip.takip_tarihi).getTime()){
      const filteredTurler = Object.values(TahsilatTuru)
          .filter(turu => turu !== TahsilatTuru.icra);
      return filteredTurler;
    } else {
      return Object.values(TahsilatTuru);
    }
  }

  get filterTurlerLabel(){
    if (new Date(this.localValue.tarih).getTime() < new Date(this.takip.takip_tarihi).getTime()){
      const filteredLabels = Object.values(TahsilatTuruLabel)
          .filter((label, index) => Object.values(TahsilatTuru)[index] !== TahsilatTuru.icra);
      return filteredLabels;
    } else {
      return Object.values(TahsilatTuruLabel);
    }
  }

  @Watch('localValue.tarih')
  onTahsilatTarihi() {
    if (new Date(this.localValue.tarih).getTime() > new Date(this.takip.takip_tarihi).getTime()) {
      this.tarihKontrol = true;
    } else {
      this.tarihKontrol = false;
    }

    const isTakipSonrasi = new Date(this.localValue.tarih).getTime() >= new Date(this.takip.takip_tarihi).getTime();

    if (this.takipSonrasi != isTakipSonrasi) {
      this.takipSonrasi = isTakipSonrasi;

      if (this.takipSonrasi) {
        if (this.takip.alacaklilar.some(item => item?.muvekkil?.kurum?.harc_muaf_mi !== true)) {
          this.localValue.tahsil_harci_orani = "4.55";
        }
        this.hesaplaHarciApiUzerinden();
      } else {
        this.localValue.tahsil_harci = 0;
        this.localValue.cezaevi_harci = 0;
        this.localValue.tahsil_harci_orani = "0.00";
        this.netTutarHesapla();
      }
    }
    this.input();
  }

  // <-- YENİ EKLENDİ: Tutar girilirken sadece parent'a haber verilir.
  onTutarInput() {
    this.input();
  }

  // <-- DEĞİŞTİ: Tutar değeri reaktif olarak değiştiğinde API'yi çağıran watcher.
  @Watch('localValue.tutar')
  onTutarChange() {
    // Önceki zamanlayıcıyı temizle
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    if (!this.takipSonrasi) {
      this.localValue.net_tutar = Number(this.localValue.tutar);
      this.input();
    } else {
      // Kullanıcı yazmayı bıraktıktan 500ms sonra isteği gönder
      this.debounceTimer = setTimeout(() => {
        this.hesaplaHarciApiUzerinden();
      }, 500); // 500 milisaniye bekle
    }
  }

  mounted() {
    // Eğer mevcut bir tahsilat varsa (edit mode), tarihine göre takipSonrasi'yi belirle
    if (this.localValue?.id && this.localValue.tarih && this.takip.takip_tarihi) {
      this.takipSonrasi = new Date(this.localValue.tarih).getTime() >= new Date(this.takip.takip_tarihi).getTime();
    } else if (this.takip.takip_durumu != TakipDurumu.acilmamis) {
      // Yeni tahsilat ekleniyorsa ve takip açıksa, takip sonrası kabul et
      this.takipSonrasi = true;
    }

    if (!this.localValue.tutar) {
      this.localValue.net_tutar = 0;
    }
    if (!this.localValue?.id) {
      this.localValue.tarih = new Date();
      this.localValue.giris_tarihi = new Date();
      this.localValue.alt_tahsilat_turu_id = null;
    }

    if (this.localValue?.id && this.takipSonrasi &&
        this.localValue.tutar &&
        (!this.localValue.tahsil_harci || Number(this.localValue.tahsil_harci) <= 0)) {
      setTimeout(() => {
        this.hesaplaHarciApiUzerinden();
      }, 500);
    }
    this.getHarcDonemi();
  }

  // <-- DEĞİŞTİ: Kur değiştiğinde de merkezi API metodunu çağırır.
  onKurChange() {
    if (this.takipSonrasi) {
      this.hesaplaHarciApiUzerinden();
    } else
      this.input();
  }

  changeTahsilHarcOran(){
    if (this.localValue.tahsil_harci_orani != "0.00" &&
        this.takip.alacaklilar.some(item =>
            item?.muvekkil?.kurum?.harc_muaf_mi === true
        )){
      this.harctanMuafMiOranAlert = true;
    } else if(this.localValue.tahsil_harci_orani == "0.00" ||
        this.takip.alacaklilar.some(item =>
            item?.muvekkil?.kurum?.harc_muaf_mi === false
        )){
      this.harctanMuafMiOranAlert = false;
    }

    if (this.localValue.tahsil_harci_orani !== "0.00") {
      this.hesaplaHarciApiUzerinden();
    }
  }

  // Tüm hesaplamaların yapıldığı merkezi API metodu.
  async hesaplaHarciApiUzerinden() {
    if (!this.takipSonrasi || !this.localValue.tutar) {
      this.localValue.tahsil_harci = "0.00"; // Değeri "0.00" olarak ayarla
      this.localValue.cezaevi_harci = 0;
      this.netTutarHesapla();
      return;
    }

    this.isHesaplaniyor = true;
    if (this.localValue.para_birimi_id == this.ParaBirimi.TRY) {
      this.localValue.kur = 1;
    }

    try {
      // Tahsil harcını hesapla
      const tahsilHarciResponse = await this.$http.post('/api/v1/takip/' + this.takip.id + '/tahsil-harci-hesapla', {
        tahsilat_id: this.localValue.id ?? null,
        tutar: this.localValue.tutar,
        tahsil_harci_orani: this.localValue.tahsil_harci_orani,
        kur: this.localValue.kur
      });

      const harcTutari = tahsilHarciResponse.data?.tahsil_harci_tutari ?? 0;
      this.localValue.tahsil_harci = Number(harcTutari).toFixed(2);

      // Cezaevi harcını hesapla (sadece icra tahsilatı için)
      if (this.localValue.tahsilat_turu === this.TahsilatTuru.icra && parseFloat(this.localValue.tahsil_harci_orani || 0) > 0) {
        const cezaeviHarciResponse = await this.$http.post('/api/v1/takip/' + this.takip.id + '/cezaevi-harci-hesapla', {
          tahsilat_id: this.localValue.id ?? null,
          tutar: this.localValue.tutar,
          tahsil_harci_orani: this.localValue.tahsil_harci_orani,
          kur: this.localValue.kur
        });

        const cezaeviHarci = cezaeviHarciResponse.data?.cezaevi_harci_tutari ?? 0;
        this.localValue.cezaevi_harci = Number(cezaeviHarci);
      } else {
        this.localValue.cezaevi_harci = 0;
      }

    } catch (error) {
      console.error("Harç hesaplama API hatası:", error);
      this.localValue.tahsil_harci = "0.00"; // Hata durumunda da "0.00" yaz
      this.localValue.cezaevi_harci = 0;
    } finally {
      this.netTutarHesapla();
      this.isHesaplaniyor = false;
      this.input();
    }
  }
  netTutarHesapla() {
    let tutar = this.localValue.tutar ?? 0;
    if (typeof tutar == 'string') tutar = Number(tutar);
    if (this.localValue.para_birimi_id != ParaBirimi.TRY && this.localValue.kur) {
      tutar *= this.localValue.kur;
    }

    if (!this.takipSonrasi) {
      this.localValue.net_tutar = this.localValue.tutar;
      return;
    }

    let tahsilHarci = Number(this.localValue.tahsil_harci || 0);
    let cezaeviHarci = Number(this.localValue.cezaevi_harci || 0);

    let netTutar = tutar - tahsilHarci - cezaeviHarci;

    if (this.localValue.para_birimi_id != ParaBirimi.TRY && this.localValue.kur) {
      netTutar /= this.localValue.kur;
    }

    this.localValue.net_tutar = isNaN(netTutar) ? 0 : netTutar;
  }

  getHarcDonemi() {
    this.$http.get("/api/v1/tahsilat-harclar").then((response) => {
      this.items = response.data;
    });
  }

  get tahsilHarciOranlari(){
    let tahsilHarc:any=[]
    this.items.forEach((item: any) => {
      if(item.oran==2.275){
        tahsilHarc.push(Number(item.oran).toFixed(3).toString());
      }else {
        tahsilHarc.push(Number(item.oran).toFixed(2).toString());
      }
    })
    tahsilHarc.push("0.00") // 0.00'ı döngü dışında, sona eklemek daha doğru
    tahsilHarc = [...new Set(tahsilHarc)]; // Tekrarları engelle

    if (this.takip.alacaklilar.some(item =>
        item?.muvekkil?.kurum?.harc_muaf_mi === true
    )){
      this.localValue.tahsil_harci_orani = "0.00";
    } else if (this.takipSonrasi &&
        (!this.localValue.tahsil_harci_orani || this.localValue.tahsil_harci_orani === "")) {
      this.localValue.tahsil_harci_orani = "4.55";
    }

    return tahsilHarc
  }

  /*get tahsilHarciOranlari() {
    let harclar !: HarcTuruEntity[];
    harclar = this.selectedItem.harclar;
    if (!harclar) {
      return null;
    }
    let harcTurleri = harclar.filter((x: any) => x.harc_turu.harc_tipi === "tahsil")
    let harcOranlari: any = [];
    harcTurleri.forEach((harcTuru) => {
      if (harcTuru.oran==2.275){
        harcOranlari.push(harcTuru.oran)
      }else{
        harcOranlari.push(Number(harcTuru.oran).toFixed(2));
      }
      harcOranlari.push("0.00");
      harcOranlari.push("0.90");
      harcOranlari.push("1.80");
      harcOranlari.push("1.98");
      harcOranlari.push("2.27");
      harcOranlari.push("3.60");
      harcOranlari.push("3.96");
      harcOranlari.push("5.00");
      harcOranlari.push("7.20");
      harcOranlari.push("7.92");
      harcOranlari.push("9.00");
      harcOranlari.push("9.90");
    });
    return harcOranlari;
  }*/

  save() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (this.localValue.borclu && this.localValue.borclu.id) {
      this.localValue.borclu_id = this.localValue.borclu.id;
    } else if (!this.localValue.borclu_id) {
      return;
    }

    if (typeof this.localValue.borclu_id === 'object' && this.localValue.borclu_id !== null) {
      this.localValue.borclu_id = (this.localValue.borclu_id as any).id;
    }

    if (this.localValue.id) {
      this.$http.put("/api/v1/tahsilat/" + this.localValue.id, this.localValue).then(() => {
        this.$emit('onSuccess');
      })
    } else {
      this.$http.post("/api/v1/takip/" + this.takip?.id + "/tahsilat/", this.localValue).then(() => {
        this.$emit('onSuccess');
      })
    }
  }

  /* Elle hesaplama yapılacak
  manuelHarcHesapla() {
    // Takip sonrası değilse veya tutar yoksa işlem yapma
    if (!this.takipSonrasi || !this.localValue.tutar) return;
    
    // Oran 0 ise hesaplama
    if (this.localValue.tahsil_harci_orani === "0.00") return;
    
    // Harç hesapla
    const tutar = Number(this.localValue.tutar);
    const oran = Number(this.localValue.tahsil_harci_orani.replace(',','.'));
    const kur = this.localValue.kur ? Number(this.localValue.kur) : 1;
    
    // Hesapla ve ata
    const hesaplananHarc = (tutar * kur * oran) / 100;
    
    if (!this.localValue.tahsil_harci || Number(this.localValue.tahsil_harci) <= 0) {
      this.localValue.tahsil_harci = hesaplananHarc;
    }
    
    // Cezaevi harcı da hesapla
    if (this.localValue.tahsilat_turu == this.TahsilatTuru.icra) {
      this.localValue.cezaevi_harci = tutar * kur * 0.02;
    }
    
    // Net tutarı hesapla
    this.netTutarHesapla();
  }*/
}
